import React from "react";
const ICON_BASE_URL = 'https://opensooqui2.os-cdn.com/api/apiV/android/xxh';
const RichText = (props) => {
    const { message } = props;
    return (React.createElement("div", { className: 'rich-text__container' },
        React.createElement("div", { className: 'rich-text__icon-box' },
            React.createElement("img", { src: `${ICON_BASE_URL}${message.rich.icon}` })),
        React.createElement("div", { className: 'rich-text__text' }, message.text)));
};
export default RichText;
